<template lang="pug">
.mb-3.round-xl(:class="cardClasses")
  .d-flex.align-center.clickable(:class="{ 'px-4 py-2 neutral300 border-selected-top':isSelected }" @click="onToggleSelection")
    .flex-grow-1
      .d-flex.flex-column
        .d-flex.mb-1(v-if="parentHistory.company && parentHistory.company.slug !== company.slug")
          yz-badge.pa-1(border size="sm" border-color="blue-500" text-color="blue-500" color="blue-100") {{ parentHistory.company.name }}
        .font-semibold.mr-4 {{ getDate }}
      .text-sm(v-if="getDoctorName") {{ $t('attended_by', { who: getDoctorName }) }}
    v-icon(v-if="isSelected") $yzi-chevron-up
    v-icon(v-else) $yzi-chevron-down
  .white.px-4.pb-2(v-if="isSelected" :class="{ 'border-selected-bottom':isSelected }")
    patient-history-item-all(v-if="category === 0" :parentHistory="parentHistory" @viewDetails="$emit('viewDetails')")
    patient-history-item-diagnosis(v-if="category === 1" :parentHistory="parentHistory" @viewDetails="$emit('viewDetails')")
    patient-history-item-medication(v-if="category === 2" :parentHistory="parentHistory" :parentRegistration="parentRegistration" :readonly="isFromOtherCompany" @updated="$emit('updated')" @viewDetails="$emit('viewDetails')")
    patient-history-item-services(v-if="category === 3" :parentHistory="parentHistory" :parentRegistration="parentRegistration" :readonly="isFromOtherCompany" @updated="$emit('updated')" @viewDetails="$emit('viewDetails')")
    patient-history-item-documents(v-if="category === 4" :parentHistory="parentHistory" @viewDetails="$emit('viewDetails')")
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import PatientHistoryItemAll from '@/components/clinic/consultation/patientHistories/PatientHistoryItemAll.vue'
import PatientHistoryItemDiagnosis from '@/components/clinic/consultation/patientHistories/PatientHistoryItemDiagnosis.vue'
import PatientHistoryItemMedication from '@/components/clinic/consultation/patientHistories/PatientHistoryItemMedication.vue'
import PatientHistoryItemServices from '@/components/clinic/consultation/patientHistories/PatientHistoryItemServices.vue'
import PatientHistoryItemDocuments from '@/components/clinic/consultation/patientHistories/PatientHistoryItemDocuments.vue'

export default {
  components: {
    PatientHistoryItemAll, PatientHistoryItemDiagnosis, PatientHistoryItemMedication, PatientHistoryItemServices, PatientHistoryItemDocuments
  },
  props: {
    parentHistory: {
      type: Object,
      required: true
    },
    parentRegistration: {
      type: Object,
      required: true
    },
    category: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isSelected: false,
      open: true
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    cardClasses() {
      return this.isSelected ? 'border-selected' : 'px-4 py-2 neutral300' 
    },
    getDate() {
      return DateTime.fromISO(this.parentHistory.record_date).toFormat('dd MMM y')
    },
    getDoctorName() {
      return this.parentHistory?.provider?.name || null
    },
    isFromOtherCompany() {
      return this.parentHistory?.company?.slug !== this.company?.slug
    },
  },
  methods: {
    onToggleSelection() {
      this.isSelected = !this.isSelected
    }
  },
}
</script>

<style lang="scss" scoped>
.border-selected {
  border: 1px solid #C1C1C1 !important;
}
.border-selected-top {
  border-radius: 10px 10px 0px 0px;
}
.border-selected-bottom {
  border-radius: 0px 0px 10px 10px;
}
</style>